import React, { useState } from "react";
import { isMobile } from "../../Utils/media-query";
import Popup, { ToolbarItem } from "devextreme-react/popup";
import useFetch from "../../Hooks/useFetch";
import { useNavigate } from "react-router-dom";
import useGetDeliveryLocations from "../../Hooks/useGET/useGetDeliveryLocations";
import handlePutDeliveryLocations from "../../Utils/handlePUT/handlePutDeliveryLocations";
import handlePostDeliveryLocations from "../../Utils/handlePOST/handlePostDeliveryLocations";
import handleDelDeliveryLocations from "../../Utils/handleDEL/handleDelDeliveryLocations";
import ErrorMessage from "../../Components/ErrorMessage";
import {
  DataGrid,
  Column,
  RequiredRule,
  Editing,
  SearchPanel,
  Button,
  Item,
  Toolbar,
} from "devextreme-react/data-grid";
import ActionNotifications from "../../Components/ActionNotifications";
import "./styles.css";

export default function DeliveryLocations() {
  const navigate = useNavigate(),
    fetch = useFetch(navigate),
    [notifyResponse, setResponse] = useState({});

  const fetchSuccessful = (response) => {
    setResponse(response);
    return (
      response?.success &&
      response?.data?.statusCode &&
      response?.success !== "Invalid Model"
    );
  };

  const { deliveryLocations, mutate, error } = useGetDeliveryLocations();

  const onRowRemoved = async (e) => {
    const { response, isDataGood } = await handleDelDeliveryLocations(
      e.data.id,
      fetch,
    );
    fetchSuccessful(response);
    if (isDataGood) mutate();
  };
  const renderGrid = () => {
    const isButtonVisible = (e) => {
      if (e.row.data.type === 1) {
        return true;
      }
      return false;
    };
    const allowEditing = async (e) => {
      const gridData = e.changes[0];

      if (gridData?.type === "update") {
        const { response, isDataGood } = await handlePutDeliveryLocations(
          gridData.data,
          fetch,
        );
        fetchSuccessful(response);
        if (isDataGood) mutate();
      } else if (gridData?.type === "insert") {
        const { response, isDataGood } = await handlePostDeliveryLocations(
          gridData.data.location,
          fetch,
        );
        fetchSuccessful(response);
        if (isDataGood) mutate();
      }
    };

    return (
      <DataGrid
        dataSource={deliveryLocations}
        onSaved={allowEditing}
        onRowRemoved={onRowRemoved}
        fullScreen={isMobile}
        showBorders={true}
      >
        <Toolbar>
          <Item
            location="before"
            locateInMenu="never"
            render={() => (
              <div>
                <h1 className="white">Delivery Location</h1>
              </div>
            )}
          />
          <Item name="addRowButton" />
          <Item name="searchPanel" />
        </Toolbar>
        <SearchPanel
          visible={true}
          searchVisibleColumnsOnly={true}
          placeholder="Search..."
        />
        <Editing allowAdding={true} allowUpdating={true} allowDeleting={true} />
        <Column type="buttons">
          <Button name="edit" />
          <Button name="delete" />
        </Column>

        <Column
          visible={false}
          dataField="id"
          alignment="left"
          allowEditing={false}
        />
        <Column dataField="location">
          <RequiredRule />
        </Column>
      </DataGrid>
    );
  };

  return (
    <div className="px-lg-4 content">
      <ActionNotifications response={notifyResponse} />
      <div className="flexBoxRowSCC">
        <div className="px-2 page-content delivery-locations-grid ">
          <div className="contentBox my-3">
            {!error ? renderGrid() : <ErrorMessage />}
          </div>
        </div>
      </div>
    </div>
  );
}
